(ns machtfit.product-form.section
  (:require [machtfit.product-form.core :as product-form]
            [machtfit.utils :refer [scroll-down]]
            [re-frame.core :as rf]))

(def ^:private section-base-order
  [:errors :what :where :when :for-whom :who :how :resale-info :how-much :visibility :promotions :save])

(rf/reg-event-db ::saw-section
  (fn [db [_ section]]
    (-> db
        (update-in [:ui :seen-sections] #(if (nil? %) #{section} (conj % section))))))

(defn show-next-section [section]
  (when-not @(rf/subscribe [::next-section-visible? section])
    ^{:key "continue"}
    [:div.clearfix
     [:div.divider
      {:style {:margin-top "0.5rem"
               :margin-bottom "1rem"}}]
     [:div.col.s12
      [:a.waves-effect.waves-light.btn.btn-large
       {:on-click #(do
                     (rf/dispatch [::saw-section section])
                     (scroll-down))}
       [:i.material-icons.left "subdirectory_arrow_right"]
       "Weiter"]]]))

(rf/reg-sub ::applicable-sections
  :<- [::product-form/machtfit-admin?]
  :<- [::product-form/machtfit-or-offer-admin?]
  :<- [:get [:options :partner-product?]]
  (fn [[machtfit-admin? machtfit-or-offer-admin? partner-product?] _]
    (let [section-applicable? ;; If this is false for a section, it won't be shown and nothing else can make it appear.
          {:what true
           :where true
           :when true
           :for-whom true
           :who true
           :how true
           :resale-info (and machtfit-admin? partner-product?)
           :how-much true
           :visibility machtfit-or-offer-admin?
           :promotions machtfit-admin?
           :save true}]
      (filterv section-applicable? section-base-order))))

(rf/reg-sub ::next-sections
  :<- [::applicable-sections]

  (fn [applicable-sections _]
    (apply hash-map (interleave applicable-sections (rest applicable-sections)))))

(rf/reg-sub ::visible-sections
  :<- [::product-form/has-errors?]
  :<- [::applicable-sections]
  :<- [:get [:ui :seen-sections]]
  :<- [::next-sections]
  :<- [::product-form/new?]

  (fn [[has-errors? applicable-sections seen-sections next-sections new?] _]
    (let [visible-sections (if new?
                             (let [;; For new products (that is, initially empty forms), show the
                                         ;; sections one by one. The first section, :what, is always
                                         ;; shown. The last visible section has a button "continue".
                                         ;; When that button is clicked, that sections is marked as
                                         ;; "seen" and the next section should be shown.

                                         ;; The canonical list of sections is [:what :where :when
                                         ;; :for-whom :who :how :how-much].
                                         ;; However, depending on certain choices the user makes in the
                                         ;; form and options the form was initialized with certain
                                         ;; sections may not be applicable and should never be shown.
                                         ;; The list of applicable sections is calculated in the
                                         ;; :applicable-sections sub.

                                         ;; At any time, the :what section is visible. The *following*
                                         ;; applicable sections are visible if they are "seen". The next
                                         ;; applicable section is visible as well, and it shows the
                                         ;; "continue" button.

                                   applicable-seen-sections (vec (take-while #(some #{%} seen-sections) applicable-sections))
                                   next-section (if (empty? applicable-seen-sections)
                                                  :what
                                                  (next-sections (last applicable-seen-sections)))]
                               (conj applicable-seen-sections next-section))
                             applicable-sections)]
      (if has-errors?
        (into [:errors] visible-sections)
        visible-sections))))

(rf/reg-sub ::next-section-visible?
  :<- [::visible-sections]
  :<- [::next-sections]

  (fn [[visible-sections next-sections] [_ section]]
    (when section (let [next-section (section next-sections)]
                    (some #{next-section} visible-sections)))))

(rf/reg-sub ::is-last-visible-section?
  :<- [::visible-sections]

  (fn [visible-sections [_ section]]
    (= section (last visible-sections))))

(rf/reg-sub ::section-configuration-active?
  :<- [:get [:product :when :has-schedule?]]
  :<- [:get [:product :when :sessions-per-signup]]
  :<- [:get [:product :when :cohesion]]
  :<- [:get [:product :where :location-type]]
  :<- [:get [:ui :last-focused-config-section]]

  (fn [[has-schedule? sessions-per-signup cohesion location-type last-focused-config-section] [_ section]]
    (let [complete? (case section
                      :when (or (= false has-schedule?)
                                (and (some? sessions-per-signup)
                                     (or (= sessions-per-signup :one-session)
                                         (some? cohesion))))

                      :where (some? location-type)
                      nil)]

      (or (not complete?)
          (= section last-focused-config-section)))))

(rf/reg-event-db ::focus-config-section
  (fn [db [_ section]]
    (assoc-in db [:ui :last-focused-config-section] section)))

(defn reset-last-focused-config-section [db]
  (assoc-in db [:ui :last-focused-config-section] nil))
